export default __webpack_public_path__ + "static/media/smartHome.077a8a9f.png";